import { useEffect } from 'react';
import { __Currency, __EventDispatcher, __Lang } from '../../../../_core/core';
import { store } from '../../../../_core/core.Store';
import { EventClass, EventType } from '../../../config/Events';
import { RESULTS_POPUP_CLOSE_DEELAY } from '../../../config/Game';
import './Popup.Results.styles.css';

const ResultsPopup = (_props?: any) => {

    const lstore = store.getState();
    const winLose = lstore.game.GAMEPLAY.totalWinOnLastDraw;

    const message = (winLose <= 0 )? __Lang.translate('n:play.loseMessage') : __Lang.replace('n:play.winMessage', { win: __Currency.format(winLose) });

    useEffect(() => {
        setTimeout(() => {
            __EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.CLEAR_POPUP);
        }, RESULTS_POPUP_CLOSE_DEELAY);
    }, [])
         
    return (
        <>
            <div className="popup-box">
                <div className="box">
                    <div className="popup-content"> { message } </div>
                </div>
            </div>
        </>
    )

}

export default ResultsPopup;